module.exports = __webpack_public_path__ + "static/semantic-icon-fitted-64ae523b1a7a06f7d3328cc75b4cc35d.png";